import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e54c6996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "legal-footer" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

import {computed} from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MaltFooter',
  setup(__props) {

    const currentYear = new Date().getFullYear();

    const legalLink = computed(() => `/legal`);
    const protectionLink = computed(() => `/about/privacy`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" © " + _toDisplayString(_unref(currentYear)) + " Malt ⋅ ", 1),
      _createElementVNode("a", {
        href: legalLink.value,
        target: "_blank",
        rel: "noreferrer nopener"
      }, _toDisplayString(_ctx.$msg('navbar.footer.cgu.cgv')), 9, _hoisted_2),
      _createTextVNode(" ⋅ "),
      _createElementVNode("a", {
        href: protectionLink.value,
        target: "_blank",
        rel: "noreferrer nopener"
      }, _toDisplayString(_ctx.$msg('navbar.footer.data.protection')), 9, _hoisted_3)
    ])
  ]))
}
}

})